export default __webpack_public_path__ + "static/media/person1.58640ad9.jpg";